import React from 'react';
import { Icon } from './Icon.js';
export const IconLineHeight = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M3 3H21", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M3 21H21", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M8.84802 14H15.1406", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M13.4834 6.65234L17.6953 18H15.5625L12 8.40234L8.4375 18H6.30469L10.5166 6.65234L10.7588 6H13.2412L13.4834 6.65234Z", fill: "currentColor", "data-stroke": "none" })));
};
//# sourceMappingURL=IconLineHeight.js.map